import React from "react";
import { Toast } from "react-bootstrap";
import "./styles.scss";
import img from "../../assets/images/contact-image.png";

const Toaster = ({ showToast, setShowToast }) => {
  return (
    <div>
      <Toast
        delay={4000}
        show={showToast}
        onClose={() => setShowToast(false)}
        autohide
        style={{
          position: "fixed",
          left: 10,
          bottom: 10,
        }}
      >
        <Toast.Header></Toast.Header>
        <Toast.Body>
          <div className="toast-body-section">
            <span>
              <img src={img} className="toast-image" alt="Helper Profile" />
            </span>
            <div>
              <h6> I'm Amanda, your roofing specialist </h6>
              <p>
                Let's get you started with getting you roof repaired in just a
                few clicks
              </p>
            </div>
          </div>
        </Toast.Body>
      </Toast>
    </div>
  );
};

export default Toaster;
